// extracted by mini-css-extract-plugin
export default {"placeholder":"placeholder-YZquz","icon":"icon-XP_Ok","trigger":"trigger-uqUbE"};